import { defineComponent, h } from "vue";
const _sfc_main = defineComponent({
  name: "ConditionalWrapper",
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: "div"
    },
    skip: {
      type: Boolean,
      required: true
    }
  },
  slots: Object,
  setup(props, { slots, attrs }) {
    return () => {
      var _a, _b;
      return props.skip ? (_a = slots.default) == null ? void 0 : _a.call(slots, {}) : h(props.tag, { ...attrs }, [(_b = slots.default) == null ? void 0 : _b.call(slots, {})]);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=ConditionalWrapper.vue_vue_type_script_lang-BLT72l8w.mjs.map
